module.exports = __webpack_public_path__ + "static/media/btn_slide_next.d015ed14.svg";